import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { investingService } from '../../services/investingService';

export const useGetInvestingStatus = () => {
  return useQuery({
    staleTime: 1000 * 3,
    refetchOnWindowFocus: true,
    queryKey: [QUERY_KEYS.investing.status],
    queryFn: () =>
      investingService.status().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
